import type { TextareaHTMLAttributes } from "react";
import { forwardRef } from "react";
import { cn } from "@/shared/utils/cn";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

// Multiline counterpart of the Input wrapper (same tracker InputAdapter
// styling: rounded-md border border-input text-sm).
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, ...props },
  ref,
) {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-alert-red",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
